import api from "@/apiConfig/api";

export const getAdminDashboard = async (userId = null) => {
  const params = {};
  if (userId) params.user_id = userId;
  return await api.get("/finance/admin-salary/dashboard", { params });
};

export const getAdminMonthlySalary = async (userId, year, month) => {
  return await api.get("/finance/admin-salary/monthly", {
    params: { user_id: userId, year, month },
  });
};

export const getAdminSalaryList = async (year, month) => {
  return await api.get("/finance/admin-salary/list", {
    params: { year, month },
  });
};

export const createAdminAttendance = async (data) => {
  return await api.post("/finance/admin-salary/attendance", data);
};

export const syncVerifix = async (forDate = null) => {
  const params = {};
  if (forDate) params.for_date = forDate;
  return await api.post("/finance/admin-salary/sync-verifix", null, { params });
};

export const syncVerifixSchedules = async () => {
  return await api.post("/finance/admin-salary/sync-verifix-schedules");
};

export const recalculateAdminSalary = async (data) => {
  return await api.post("/finance/admin-salary/recalculate", data);
};

export const getSalaryPinStatus = async () => {
  return await api.get("/finance/admin-salary/pin/status");
};

export const setSalaryPin = async (pin, pinConfirm) => {
  return await api.post("/finance/admin-salary/pin/set", {
    pin,
    pin_confirm: pinConfirm,
  });
};

export const verifySalaryPin = async (pin) => {
  return await api.post("/finance/admin-salary/pin/verify", { pin });
};
